import { List as RefineList } from "@refinedev/antd";
import { Flex, Spin } from "antd";
import { Tabs } from "@libertify/ui";
import { useGetActiveSubscriptions } from "#src/hooks";
import { useTranslate } from "@refinedev/core";
import { CircleNotchIcon } from "@phosphor-icons/react";
import CurrentSubscriptionCard from "./CurrentSubscriptionCard";
import BillingHistoryTable from "./BillingHistoryTable";
import { useSubscriptionInvoices } from "../hooks/useSubscriptionInvoices";

const Subscription = () => {
  const t = useTranslate();
  const { subscriptions, isLoading } = useGetActiveSubscriptions();
  const { invoices, isLoading: invoicesLoading } = useSubscriptionInvoices();

  if (isLoading) {
    return (
      <Flex justify="center" align="center" style={{ minHeight: 300 }}>
        <Spin indicator={<CircleNotchIcon style={{ fontSize: 60 }} />} />
      </Flex>
    );
  }

  const items = [
    {
      key: "overview",
      label: t("pages.subscription.tabs.overview"),
      children: <CurrentSubscriptionCard subscription={subscriptions} />,
    },
    ...(invoices.length > 0
      ? [
          {
            key: "billingHistory",
            label: t("pages.subscription.tabs.billingHistory"),
            children: (
              <BillingHistoryTable
                invoices={invoices}
                isLoading={invoicesLoading}
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <RefineList title={t("pages.subscription.title")} headerButtons={<></>}>
      <Tabs items={items} />
    </RefineList>
  );
};

export default Subscription;
